import { useShallow } from "zustand/react/shallow";
import { useSessionStore } from "../session.store";
import type { Session } from "../types";

export function useSession() {
    return useSessionStore(useShallow((state) => state.computed.selectedSession() as unknown as Session));
}
